import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ComparisonNodeBaseModel } from '../../models';
import { getVisibleComparisonGroups } from '../../misc';
import { ContractComparisonPanelRenderer } from '..';
import { useAppStore } from '../../stores';

interface Props {
    comparisonNode: ComparisonNodeBaseModel;
}

const ContractComparisonPanelsRenderer: React.FC<Props> = ({ comparisonNode }) => {
    const { contractComparisonStore } = useAppStore();

    const groups = getVisibleComparisonGroups(comparisonNode.groups, contractComparisonStore.selectedFilter);

    return (
        <>
            {comparisonNode.panels.map(panel => (
                <ContractComparisonPanelRenderer
                    key={panel.id}
                    panelId={panel.id}
                    panelName={panel.name}
                    nodeId={comparisonNode.nodeId}
                    groups={groups.filter(group => group.panelId === panel.id)}
                />
            ))}
        </>
    );
};

export default observer(ContractComparisonPanelsRenderer);
